const es = {
  common: {
    email: 'Email',
    username: 'Usuario',
    password: 'Contraseña',
    search: 'Buscar',
    continue: 'Continuar',
    ok: 'Aceptar',
    cancel: 'Cancelar',
    save: 'Guardar',
    delete: 'Eliminar',
    close: 'Cerrar',
    move: 'Mover',
    restore: 'Restaurar',
    edit: 'Editar',
    addMenu: 'Crear un nuevo menú',
    addContent: 'Añadir al menú',
    addToSubmenu: 'Añadir al submenú',
    addSubmenu: 'Crear submenú',
    language: 'idioma',
    struct: 'Estructura',
    selectImage: 'Añadir imagen',
    height: 'Altura',
    url: 'URL',
    text: 'Texto',
    comment: 'Comentario',

    collapse: 'Contraer',
    expand: 'Expandir',

    today: 'Hoy',
    tomorrow: 'Mañana',
    m0: 'Enero',
    m1: 'Febrero',
    m2: 'Marzo',
    m3: 'Abril',
    m4: 'Mayo',
    m5: 'Junio',
    m6: 'Julio',
    m7: 'Agosto',
    m8: 'Septiembre',
    m9: 'Octubre',
    m10: 'Noviembre',
    m11: 'Diciembre',
    dayOfWeek: {
      0: 'Domingo',
      1: 'Lunes',
      2: 'Martes',
      3: 'Miércoles',
      4: 'Jueves',
      5: 'Viernes',
      6: 'Sábado'
    },

    addToCalendar: 'Añadir al calendario',
    error2mb: 'La imágen no puede superar los 2MB',
    selectMenu: 'Seleccione el menú al que mover el contenido',
    addressToSearch: 'Dirección a buscar',
    history: 'Historial'
  },
  login: {
    title: 'Formulario de acceso',
    login: 'acceder',
    messages: {
      required: 'El usuario y la contraseña son requeridos',
      userNotFound: 'El usuario o la contraseña no son correctos'
    }
  },
  dashboard: {
    title: 'Dashboard',
    changePassword: 'Cambiar contraseña',
    logout: 'Salir',
    changeEnterprise: 'Cambiar empresa',
    addReservation: 'Añadir reserva'
  },
  changePassword: {
    oldPassword: 'Contraseña anterior',
    password: 'Nueva contraseña',
    repeatPassword: 'Repetir contraseña',
    messages: {
      oldPasswordRequired: 'La contraseña anterior es requerida',
      passwordRequired: 'La contraseña es requerida',
      sameAsPassword: 'Las contraseñas deben coincidir',
      UserNotFound: 'El usuario o la contraseña no coinciden',
      success: 'Contraseña actualizada correctamente'
    }
  },
  users: {
    title: 'Usuarios',
    userTitle: 'Usuario',
    name: 'Usuario',
    email: 'Email',
    client: 'Cliente',
    password: 'Contraseña',
    repeatPassword: 'Repetir contraseña',
    isSuperUser: '¿Es super usuario?',
    enterprises: 'Grupos',
    defaultEnterprise: 'Cliente por defecto',
    permissions: {
      title: 'Permisos',
    },
    notification: 'Notificar'
  },
  enterprises: {
    title: 'Grupos',
    enterpriseTitle: 'Grupo',
    name: 'Grupo',
    domain: 'Dominio',
    privateBGColor: 'Color de fondo del gestor',
    permissions: 'Permisos',
    dviewLink: 'Actividades (enlace Dview)',
    dviewLinkShows: 'Cartelera (enlace Dview)',
    dviewLinkAgenda: 'Agenda (enlace Dview)',
    dviewLinkParrilla: 'Parrilla (enlace Dview)',
    dviewLinkCommercial: 'Agentes (enlace Dview)',
    dviewLinkProperty: 'Propiedades (enlace Dview)',
    showMoscaDFeel: 'Mostrar mosca DFeel',
    meteo: 'Meteo (lugar)',
    linkCommon: 'Enlazar menús compartidos',
    clearStats: 'Resetear estadísticas',
    messages: {
      nameMostCharacters: 'El nombre no puede superar los 50  caracteres',
      nameRequired: 'El email es requerido',
      domainMostCharacters: 'El dominio no puede superar los 50  caracteres',
      domainRequired: 'El dominio es requerido',
    }
  },
  playerSettings: {
    title: 'Players',
    playerSettingTitle: 'Player',
    name: 'Nombre',
    token: 'Token',
    delay: 'Delay'
  },
  status: {
    title: 'Estado'
  },
  confirmDelete: {
    title: '¿Desea eliminar este contenido?',
    message: 'Esta accion no se puede deshacer'
  },
  confirmUndo: {
    title: '¿Desea continuar?',
    message: 'Perderá los cambios no guardados'
  },
  statusRoom: {
    scheduleMeeting: 'Programar reunión'
  }
}
  
export default es
  
